import React, { Component } from "react";
import { Link } from "react-router-dom";
import { HiOutlineArrowSmallLeft } from "react-icons/hi2";
import { Image, Typography } from "antd";
import { removeStorageWhenLogout, statusHtmlStorage } from "../../config/helper";
import forgotIcon from "../../assets/img/image-forgot.png";
import styles from "./forgot.module.css";

class ForgotPasswordSuccess extends Component {
  constructor(props) {
    super(props);
    this.forgotEmail = localStorage.getItem("forgot-email");
  }

  componentDidMount() {
    if (!statusHtmlStorage("forgot-message")) {
      removeStorageWhenLogout();
      window.location.href = "/signin";
    }
    // setTimeout(() => {
    //   window.location.href = "/signin";
    // }, 120000);
  }

  render() {
    return (
      <div className={styles.auth_forgot_page}>
        <div className={styles.auth_wrapper}>
          <Link to="/signin" className={styles.btn_back_login}>
            <HiOutlineArrowSmallLeft style={{ fontSize: 24 }} />
          </Link>
          <div className={styles.forgot_success_wrapper}>
            <Image preview={false} src={forgotIcon} />
            <Typography.Title level={3}>Check Your Inbox</Typography.Title>
            <Typography.Paragraph>
              We've sent an email to {this.forgotEmail}. Please check your inbox
              for further instructions on resetting your password.
            </Typography.Paragraph>
            <Typography.Paragraph>
              Note: If you don't see the email in your inbox, please check your
              spam or junk folder.
            </Typography.Paragraph>
          </div>
        </div>
      </div>
    );
  }
}

export default ForgotPasswordSuccess;
